<div class="avatar-crop-container">
  <div fxLayout="column" fxLayoutGap="15px">
    <div fxLayout="row">
      <h3>Zmiana zdjęcia</h3>
    </div>
  </div>

  <div fxLayout="row" *ngIf="progress < 100">
    <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
  </div>

  <div fxLayout="row">
    <image-cropper class="cropper"
      [maintainAspectRatio]="maintainRatio"
      [aspectRatio]="ratio"
      [roundCropper]="roundCropper"
      format="jpeg"
      (imageCropped)="imageCropped($event)"
      (loadImageFailed)="loadImageFailed()"
      [imageBase64]="fileBase64"
    ></image-cropper>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="save()" mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>

    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>

